export default __webpack_public_path__ + "static/media/4.95d53670.jpg";